import { isStorybook } from './useEnv'

let sessionDataConstants = {}
const globalSessionData = window.TEAMUP_USER_SESSION_DATA

// mock
// globalSessionData.enterprise_client = 'peloton'

function updateSessionDataConstants(sessionData, force = false) {
  if (Object.keys(sessionDataConstants).length && !force)
    return
  const accessToken = sessionData?.access_token
  const currentProviderId = sessionData?.current_provider
  const hasProviderId = currentProviderId > 0
  const currentProvider = (sessionData?.providers || []).find(provider => provider.id === currentProviderId)
  const hasOnlyOneProvider = sessionData?.providers?.length === 1
  const currentOrOnlyProvider = currentProvider || (hasOnlyOneProvider ? sessionData?.providers?.[0] : undefined)
  const currentProviderName = currentProvider?.name
  const emptyProviderLogoUrl = '/uploads/provider_logos/default.png?w={width}&h={height}'
  const currentProviderLogoUrl = (currentOrOnlyProvider?.logo?.url !== emptyProviderLogoUrl)
    ? currentOrOnlyProvider?.logo?.url
    : undefined

  const currentProviderTheme = currentOrOnlyProvider?.theme
  const currentProviderSlug = currentOrOnlyProvider?.url_slug
  const currentProviderPrefix = `/p/${currentProviderSlug}`
  const currentCustomer = sessionData?.current_customer
  const currentCustomerId = currentCustomer?.id
  const familyId = currentCustomer?.family?.id
  const isAuthenticated = sessionData?.user?.id > 0
  const hasCustomerId = currentCustomerId > 0
  const hasFamily = !!currentCustomer?.family
  const ontologies = sessionData?.ontologies
  const gtagId = sessionData?.google_analytics?.tag_id
  const alerts = sessionData?.ui_alerts || []
  const calendarSettings = sessionData?.calendar_settings
  const unagreedPolicies = sessionData?.unagreed_policies
  const hasUnagreedPolicies = unagreedPolicies?.length > 0
  const enterpriseClient = sessionData?.enterprise_client
  const showPriceInclusiveOfFees = sessionData?.show_price_inclusive_of_fees

  sessionDataConstants = {
    accessToken,
    alerts,
    calendarSettings,
    currentCustomerId,
    currentOrOnlyProvider,
    currentProvider,
    currentProviderId,
    currentProviderLogoUrl,
    currentProviderName,
    currentProviderPrefix,
    currentProviderSlug,
    currentProviderTheme,
    emptyProviderLogoUrl,
    enterpriseClient,
    familyId,
    gtagId,
    hasCustomerId,
    hasFamily,
    hasOnlyOneProvider,
    hasProviderId,
    hasUnagreedPolicies,
    isAuthenticated,
    ontologies,
    unagreedPolicies,
    showPriceInclusiveOfFees,
  }
}

updateSessionDataConstants(globalSessionData)

export function useSessionData() {
  let sessionData
  if (isStorybook) {
    sessionData = inject('mockSessionData', undefined)
    if (!sessionData)
      sessionData = window.TEAMUP_USER_SESSION_DATA
    updateSessionDataConstants(sessionData, true)
  }
  else {
    sessionData = globalSessionData
  }
  return {
    sessionData,
    ...sessionDataConstants,
  }
}

const {
  accessToken,
  currentProviderId,
  currentProviderName,
  currentProvider,
  currentCustomerId,
  familyId,
  gtagId,
  hasFamily,
  hasCustomerId,
  isAuthenticated,
  ontologies,
} = sessionDataConstants

export {
  accessToken,
  currentProviderId,
  currentProviderName,
  currentProvider,
  currentCustomerId,
  familyId,
  gtagId,
  hasFamily,
  hasCustomerId,
  isAuthenticated,
  ontologies,
}
